import Chip, { ChipProps } from '@material-ui/core/Chip';
import React from 'react';
import ExecutionConstants, { ActionState } from './ExecutionConstants';

interface Props {
    state: ActionState;
    chipProps?: ChipProps;
}

function ExecutionActionStatusChip(props: Props) {
    const { state, chipProps } = props;
    const color = ExecutionConstants.ActionStateColors[state];
    return <Chip
        {...chipProps}
        variant="outlined"
        label={ExecutionConstants.ActionStateLabels[state]}
        style={{ color, borderColor: color }}
    />
};

export default ExecutionActionStatusChip;
